import { render, staticRenderFns } from "./attractivness.vue?vue&type=template&id=9069fcd8&scoped=true&"
import script from "./attractivness.vue?vue&type=script&lang=js&"
export * from "./attractivness.vue?vue&type=script&lang=js&"
import style0 from "./attractivness.vue?vue&type=style&index=0&id=9069fcd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9069fcd8",
  null
  
)

export default component.exports